import { environment } from "./environment.base";
export { environment };

environment.name = 'gourav';
environment.parentUrl =  'https://gourav.strayos.com';
environment.baseUrl = 'https://gouravdashboards.strayos.com';
environment.apiUrl = 'https://devx.strayos.com:3034';